import Image from "next/image";
import cn from "classnames";
import { Button } from "components/UI/Buttons/Button";
import { academicLevels } from "content/samples/_academic-levels";
import { citationStyles } from "content/samples/_citation-styles";
import { academicDisciplines } from "content/samples/_academic-disciplines";
import { paperTypes } from "content/samples/_paper-types";
import { upperFirst } from "lodash";
import prettyBytes from "pretty-bytes";
import styles from "./SampleCard.module.scss";
import cs from "@/styles/modules/card.module.scss";

export type SamplePageSampleCardProps = {
  title: string;
  units: number;
  idAcademicLevel: number;
  idCitationStyle: number;
  idAcademicDiscipline: number;
  idPaperType: number;
  file: string;
  fileSize: number;
  type?: "default" | "landing";
  className?: string;
  onClick: () => void;
};

// TODO: temporary clone - ContentSampleCard (duplicate changes)
export const SamplePageSampleCard = ({
  className,
  title,
  units,
  idAcademicLevel,
  idCitationStyle,
  idAcademicDiscipline,
  idPaperType,
  file,
  type = "default",
  fileSize,
  onClick,
}: SamplePageSampleCardProps) => {
  const current = {
    academicLevel: academicLevels.find(({ id }) => id === idAcademicLevel),
    citationStyle: citationStyles.find(({ id }) => id === idCitationStyle),
    academicDiscipline: academicDisciplines.find(({ id }) => id === idAcademicDiscipline),
    paperType: paperTypes.find(({ id }) => id === idPaperType),
  };

  return (
    <div className={cn(cs.cardGlassHover, styles.wrapper, styles[`type${upperFirst(type)}`], className)}>
      <div className={styles.content}>
        <div className={styles.head}>
          <div className={styles.heading}>{title}</div>
          <div className={styles.tags}>
            <div className={styles.tag}>{current.academicDiscipline?.customerName}</div>
          </div>
        </div>
        <div className={styles.specs}>
          <div className={styles.spec}>
            <div className={styles.specHeading}>Pages:</div>
            <div className={styles.specValue}>{units}</div>
          </div>
          <div className={styles.spec}>
            <div className={styles.specHeading}>Level:</div>
            <div className={styles.specValue}>{current.academicLevel?.customerName}</div>
          </div>
          <div className={styles.spec}>
            <div className={styles.specHeading}>Paper type:</div>
            <div className={styles.specValue}>{current.paperType?.customerName}</div>
          </div>
          <div className={styles.spec}>
            <div className={styles.specHeading}>Format:</div>
            <div className={styles.specValue}>{current.citationStyle?.customerName}</div>
          </div>
        </div>
      </div>
      <div className={styles.download}>
        <div className={styles.file}>
          <div className={styles.fileSize}>{prettyBytes(fileSize)}</div>
          <div className={styles.fileIcon}>
            <Image src="/img/components/sample-card/pdf.svg" alt="" width={40} height={40} />
          </div>
        </div>
        <div className={styles.buttons}>
          <Button
            className={styles.button}
            type="white"
            href={`/samples/${file}`}
            isExternalLink
            download
            outline
            icon="download"
            iconPosition="suffix"
          >
            Download
          </Button>
          <Button
            className={styles.button}
            type={type === "default" ? "primary" : "accent"}
            outline={type === "default"}
            onClick={onClick}
          >
            Order similar
          </Button>
        </div>
      </div>
    </div>
  );
};
